import { useSelector } from 'react-redux';
import { getEstimatedDuration } from '../utils/utils';

export default function useEstimatedDuration() {
  const { devis } = useSelector((s) => ({
    devis: s.diag.devis,
  }));
  return getEstimatedDuration(devis.quote_elements);
}
